<template>
  <div class="Foot-area">
    <div class="container">
      <div class="foot-top dis_flex dis_jucontween">
        <div class="left">
          <div class="tip">免费咨询电话</div>
          <div class="phone">400-677-1996</div>
          <!-- <div class="phone">18337409662</div> -->
          <div class="address">地址：河南省许昌市襄城县紫云镇工业园区</div>
        </div>
        <div class="right">
          <div class="bottom-nav">
            <router-link to="/aboutus">关于万杰</router-link>
            <router-link to="/productCenter">产品展示</router-link>
            <router-link to="/news/company">新闻动态</router-link>
            <router-link to="/relationship/members">投资者关系</router-link>
            <router-link to="/contactus/message">联系我们</router-link>
          </div>
          <div class="links dis_flex flex_wrap">
            <span>友情链接：</span>
            <div style="flex: 1">
              <a :href="link.url" :title="link.name" target="_blank" v-for="link in linkList" :key="link.id">{{ link.name }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="foot-center ewms dis_flex flex_wrap">
        <div
          class="img"
          v-for="(item, index) in [
            {
              img: 'http://wxsmjphoto.wanjiejixie.com/web_img/001.png',
              name: '微信视频号',
            },
            {
              img: 'http://wxsmjphoto.wanjiejixie.com/web_img/002.png',
              name: '快手：面条机',
              tip: 'ID：1653631971',
            },
            {
              img: 'http://wxsmjphoto.wanjiejixie.com/web_img/003.png',
              name: '抖音：面条机',
              tip: 'ID：miantiaoji777',
            },
            {
              img: 'http://wxsmjphoto.wanjiejixie.com/web_img/004.png',
              name: '快手：馒头机',
              tip: 'ID：mantouji666',
            },
            {
              img: 'http://wxsmjphoto.wanjiejixie.com/web_img/005.png',
              name: '抖音：馒头机',
              tip: 'ID：mantouji666',
            },
          ]"
          :key="index"
        >
          <img :src="item.img" />
          <div class="title">{{ item.name }}</div>
          <div class="tip" v-if="item.tip">{{ item.tip }}</div>
        </div>
      </div>
      <div class="foot-bottom">
        CORPYRIGHT © 万杰智能科技股份有限公司 All Rights Reserved.
        <a href="http://wxsmjphoto.wanjiejixie.com/gs/wjzhizhao.png" target="_blank">营业执照</a><a href="http://beian.miit.gov.cn/" target="_blank">豫ICP备10008366号</a>
        <a href="https://www.beian.gov.cn/"><img src="../assets/rz11.png" alt="" width="20px" style="vertical-align: sub; display: inline-block" /> 豫公网安备41102502000196号</a>
        <div id="tongji"></div>
      </div>
    </div>
    <el-backtop :bottom="100"></el-backtop>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkList: [],
    };
  },
  mounted() {
    this.getLinks();
  },
  methods: {
    getLinks() {
      this.$https
        .fetchPost('/api/getfriendship', {})
        .then((res) => {
          // console.log(res.data)
          this.linkList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {},
};
</script>
<style lang="less">
.Foot-area {
  background-color: #1f1f23;
  a:hover {
    color: #22bdc1 !important;
  }
  .foot-top {
    padding: 60px 0 30px;
    .left {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #b5b5b5;
      .phone {
        font-family: SFUDINMittelschrift;
        font-size: 32px;
        font-weight: bold;
        font-stretch: normal;
        margin-top: 10px;
        letter-spacing: 0px;
        color: #22bdc1;
      }
      .address {
        margin-top: 20px;
      }
    }
    .right {
      width: 57%;
      .bottom-nav {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #727272;
        a {
          color: #727272;
          display: inline-block;
          position: relative;
          &:not(:last-child) {
            margin-right: 40px;
            padding-right: 40px;
          }
          &:not(:last-child):after {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            width: 1px;
            height: 16px;
            margin-top: -8px;
            background: #727272;
          }
        }
      }
      .links {
        margin-top: 25px;
        max-width: 760px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #727272;
        a {
          color: #727272;
          margin-right: 10px;
          display: inline-block;
        }
      }
    }
  }
  .foot-center {
    padding-bottom: 40px;
    margin-top: 20px;
    justify-content: space-between;
    .img {
      img {
        width: 100px;
        height: 100px;
        // background: #fff;
      }
    }
    .title {
      margin-top: 8px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #727272;
    }
    .tip {
      margin-top: 5px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #727272;
    }
  }
  .foot-bottom {
    line-height: 80px;
    border-top: 1px solid #363639;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    text-align: center;
    color: #616162;
    a {
      color: #616162;
      margin-left: 5px;
    }
  }
}
#tongji {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue